
export function FileDownload (props) {
  let linkText = props.children[0]
  let linkID = props.mark.file.asset._ref
  let linkURL = linkID.split('-')[1]
  let linkExt = linkID.split('-')[2]
  linkURL = `https://cdn.sanity.io/files/${process.env.SANITY_STUDIO_API_PROJECT_ID}/${process.env.SANITY_STUDIO_API_DATASET}/${linkURL}.${linkExt}`
  return <a href={linkURL} target='_blank' rel='noopener noreferrer'>{linkText}</a>
}
